import { type ComponentProps, useState } from 'react';
import { Link, Text } from '@optiaxiom/react';

type ExpandableTextProps = {
  maxLength?: number;
} & ComponentProps<typeof Text>;

export function ExpandableText({ maxLength = 150, children, ...textProps }: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const text = typeof children === 'string' ? children : '';

  if (text.length <= maxLength) {
    return <Text {...textProps}>{text}</Text>;
  }

  return (
    <Text {...textProps}>
      {isExpanded ? text : text.slice(0, maxLength) + '... '}{' '}
      <Link cursor="pointer" onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? 'Show less' : 'Read more'}
      </Link>
    </Text>
  );
}
